import { useSearchParams } from 'next/navigation';

import UIResource from '@/components/UIResource';
import { resetAllFilters, resetFilters } from '@/ducks/filters/setters';
import { type FiltersKey } from '@/ducks/filters/types';
import { getQFSearchParams } from '@/features/quickFindFilters/helpers';
import { useQFActiveLink } from '@/features/quickFindFilters/hooks';

import TrueZeroResults from './TrueZeroResults';

const QFTrueZeroResults = () => {
  const searchParams = useSearchParams();
  const activeQFLink = useQFActiveLink();

  const resetUserFilters = () => {
    if (activeQFLink) {
      const linkParams = getQFSearchParams(activeQFLink);
      const keys = [...searchParams.keys()].reduce((acc, key) => {
        if (!linkParams.has(key)) {
          acc.push(key as FiltersKey);
        }
        return acc;
      }, [] as FiltersKey[]);

      resetFilters(keys);
    }
  };

  return (
    <TrueZeroResults
      description={<UIResource id="ChooseVoyage.ZeroResults.QFheading" values={{ label: activeQFLink?.linkTitle }} />}
      emoji={<UIResource id="ChooseVoyage.ZeroResults.QFemojis" />}
      firstButtonText={<UIResource id="ChooseVoyage.ZeroResults.QFprimaryCTA" />}
      onFirstButtonClick={resetUserFilters}
      onSecondButtonClick={resetAllFilters}
      secondButtonText={<UIResource id="ChooseVoyage.ZeroResults.QFsecondaryCTA" />}
    />
  );
};

export default QFTrueZeroResults;
